module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(6);
}, /* 1 */
, /* 2 */
, /* 3 */
, /* 4 */
, /* 5 */
, /* 6 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.Label = exports.FieldBase = void 0;
    var _extends2 = __webpack_require__(7), _extends3 = _interopRequireDefault(_extends2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _FieldBase = __webpack_require__(14), _FieldBase2 = _interopRequireDefault(_FieldBase), _Label = __webpack_require__(24), _Label2 = _interopRequireDefault(_Label);
    exports.FieldBase = _FieldBase2.default, exports.Label = _Label2.default;
    var ON_BLUR_KEY = "onBlurKey", ON_CONTENT_BLUR_KEY = "onContentBlurKey", _class = function(_PureComponent) {
        function _class() {
            var _ref, _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, _class);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, 
            _getPrototypeOf2.default)(_class)).call.apply(_ref, [ this ].concat(args))), _this.state = {
                isFocused: _this.props.defaultIsFocused,
                isDialogFocused: !1,
                shouldIgnoreNextDialogBlur: !1
            }, _this.onFocus = function(e) {
                _this.setState({
                    isFocused: !0
                }), _this.props.onFocus(e), // Escape from a possible race-condition when blur and focus happen one by one
                // (otherwise the dialog might be left closed)
                _this.cancelSchedule(ON_BLUR_KEY);
            }, _this.onBlur = function(e) {
                // Because the blur event fires before the focus event, we want to make sure that we don't
                // render and close the dialog before we can check if the dialog is focused.
                _this.reschedule(ON_BLUR_KEY, function() {
                    return _this.setState({
                        isFocused: !1
                    });
                }), _this.props.onBlur(e);
            }, _this.onContentFocus = function() {
                _this.state.isDialogFocused ? // If we are tabbing between two elements in the warning dialog, we need to prevent the
                // dialog from closing.
                _this.setState({
                    shouldIgnoreNextDialogBlur: !0
                }) : _this.setState({
                    isDialogFocused: !0
                }), // Escape from a possible race-condition when blur and focus happen one by one
                // (otherwise the dialog might be left closed)
                _this.cancelSchedule(ON_CONTENT_BLUR_KEY);
            }, _this.onContentBlur = function() {
                _this.reschedule(ON_CONTENT_BLUR_KEY, function() {
                    _this.state.shouldIgnoreNextDialogBlur ? // Ignore the blur event if we are still focused in the dialog.
                    _this.setState({
                        shouldIgnoreNextDialogBlur: !1
                    }) : _this.setState({
                        isDialogFocused: !1
                    });
                });
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        return (0, _inherits3.default)(_class, _PureComponent), (0, _createClass3.default)(_class, [ {
            key: "cancelSchedule",
            value: function(key) {
                this.timers = this.timers || {}, this.timers[key] && (clearTimeout(this.timers[key]), 
                delete this.timers[key]);
            }
        }, {
            key: "reschedule",
            value: function(key, callback) {
                var _this2 = this;
                // Use reschedule (not just schedule) to avoid race conditions when multiple blur events
                // happen one by one.
                this.timers = this.timers || {}, this.cancelSchedule(key), this.timers[key] = setTimeout(function() {
                    callback(), _this2.cancelSchedule(key);
                }, 0);
            }
        }, {
            key: "render",
            value: function() {
                return _react2.default.createElement(_FieldBase2.default, (0, _extends3.default)({}, this.props, {
                    isDialogOpen: this.state.isFocused || this.state.isDialogFocused,
                    isFocused: this.state.isFocused,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    onDialogFocus: this.onContentFocus,
                    onDialogBlur: this.onContentBlur
                }));
            }
        } ]), _class;
    }(_react.PureComponent);
    _class.propTypes = {
        /** focus the element when initially rendered */
        defaultIsFocused: _react.PropTypes.bool,
        /** focus event handler */
        onFocus: _react.PropTypes.func,
        /** blur event handler */
        onBlur: _react.PropTypes.func
    }, _class.defaultProps = {
        defaultIsFocused: !1,
        onFocus: function() {},
        onBlur: function() {}
    }, exports.default = _class;
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(15), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _classnames = __webpack_require__(16), _classnames2 = _interopRequireDefault(_classnames), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _spinner = __webpack_require__(17), _spinner2 = _interopRequireDefault(_spinner), _warning = __webpack_require__(18), _warning2 = _interopRequireDefault(_warning), _inlineDialog = __webpack_require__(19), _inlineDialog2 = _interopRequireDefault(_inlineDialog), _styles = __webpack_require__(20), _styles2 = _interopRequireDefault(_styles), FieldBase = function(_PureComponent) {
        function FieldBase() {
            return (0, _classCallCheck3.default)(this, FieldBase), (0, _possibleConstructorReturn3.default)(this, (FieldBase.__proto__ || (0, 
            _getPrototypeOf2.default)(FieldBase)).apply(this, arguments));
        }
        return (0, _inherits3.default)(FieldBase, _PureComponent), (0, _createClass3.default)(FieldBase, [ {
            key: "componentDidUpdate",
            value: function() {
                this.props.shouldReset && this.props.onBlur();
            }
        }, {
            key: "renderRightGutter",
            value: function() {
                return !this.props.isDisabled && this.props.isInvalid ? _react2.default.createElement("div", {
                    className: _styles2.default.warningIconWrapper
                }, _react2.default.createElement(_warning2.default, {
                    label: "warning",
                    size: "medium"
                })) : this.props.isLoading ? _react2.default.createElement(_spinner2.default, null) : null;
            }
        }, {
            key: "render",
            value: function() {
                var _classNames, _classNames3, contentClasses = (0, _classnames2.default)(_styles2.default.contentContainer, (_classNames = {}, 
                (0, _defineProperty3.default)(_classNames, _styles2.default.none, "none" === this.props.appearance), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.subtle, "subtle" === this.props.appearance), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.compact, this.props.isCompact), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.disabled, this.props.isDisabled), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.readOnly, this.props.isReadOnly), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.paddingDisabled, this.props.isPaddingDisabled), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.fitContainerWidth, this.props.isFitContainerWidthEnabled), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.focused, this.props.isFocused), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.invalid, this.props.isInvalid && !this.props.isFocused), 
                _classNames)), dialogWrapperClasses = (0, _classnames2.default)(_styles2.default.dialogContainer, (0, 
                _defineProperty3.default)({}, _styles2.default.fitContainerWidth, this.props.isFitContainerWidthEnabled)), contentWrapperClasses = (0, 
                _classnames2.default)(_styles2.default.contentWrapper, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, _styles2.default.fitContainerWidth, this.props.isFitContainerWidthEnabled), 
                (0, _defineProperty3.default)(_classNames3, _styles2.default.disabled, this.props.isDisabled), 
                _classNames3));
                return _react2.default.createElement("div", {
                    className: contentWrapperClasses
                }, _react2.default.createElement("div", {
                    className: dialogWrapperClasses
                }, _react2.default.createElement(_inlineDialog2.default, {
                    position: "right middle",
                    isOpen: this.props.isDialogOpen && !!this.props.invalidMessage,
                    content: this.props.invalidMessage,
                    shouldFlip: [ "top" ],
                    onContentBlur: this.props.onDialogBlur,
                    onContentClick: this.props.onDialogClick,
                    onContentFocus: this.props.onDialogFocus
                }, _react2.default.createElement("div", {
                    className: contentClasses,
                    onFocusCapture: this.props.onFocus,
                    onBlurCapture: this.props.onBlur
                }, this.props.children, this.renderRightGutter()))));
            }
        } ]), FieldBase;
    }(_react.PureComponent);
    FieldBase.propTypes = {
        /**
	    * controls the appearance of the field.
	    * subtle shows styling on hover.
	    * none hides all field styling.
	    */
        appearance: _react.PropTypes.oneOf([ "standard", "none", "subtle" ]),
        /** children to render as dialog */
        children: _react.PropTypes.node,
        /** message to show on the dialog when isInvalid and isDialogOpen  are true */
        invalidMessage: _react.PropTypes.node,
        /** applies compact styling, making the field smaller */
        isCompact: _react.PropTypes.bool,
        /** controls whether to show or hide the dialog */
        isDialogOpen: _react.PropTypes.bool,
        /** disable the field and apply disabled styling */
        isDisabled: _react.PropTypes.bool,
        /** whether the fit the field to the enclosing container */
        isFitContainerWidthEnabled: _react.PropTypes.bool,
        /** apply styling based on whether the field is focused */
        isFocused: _react.PropTypes.bool,
        /** set the field as invalid, triggering style and message */
        isInvalid: _react.PropTypes.bool,
        /** show a loading indicator */
        isLoading: _react.PropTypes.bool,
        /** disable padding styles */
        isPaddingDisabled: _react.PropTypes.bool,
        /** apply read only styling */
        isReadOnly: _react.PropTypes.bool,
        /** mark the field as required */
        isRequired: _react.PropTypes.bool,
        /** handler for the onBlur event on the field element */
        onBlur: _react.PropTypes.func.isRequired,
        /** handler for the onBlur event on the dialog element */
        onDialogBlur: _react.PropTypes.func,
        /** handler for the click event on the dialog element */
        onDialogClick: _react.PropTypes.func,
        /** handler for the focus event on the dialog element */
        onDialogFocus: _react.PropTypes.func,
        /** handler for the focus event on the field element */
        onFocus: _react.PropTypes.func.isRequired,
        /** whether to call the onBlur handler inside componentDidUpdate */
        shouldReset: _react.PropTypes.bool
    }, FieldBase.defaultProps = {
        appearance: "standard",
        invalidMessage: "",
        isCompact: !1,
        isDialogOpen: !1,
        isDisabled: !1,
        isFitContainerWidthEnabled: !1,
        isFocused: !1,
        isInvalid: !1,
        isLoading: !1,
        isPaddingDisabled: !1,
        isReadOnly: !1,
        isRequired: !1,
        onDialogBlur: function() {},
        onDialogClick: function() {},
        onDialogFocus: function() {},
        shouldReset: !1
    }, exports.default = FieldBase;
}, /* 15 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 17 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/spinner");
}, /* 18 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/icon/glyph/warning");
}, /* 19 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/inline-dialog");
}, /* 20 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(21);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(23)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 21 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(22)(), // imports
    // module
    exports.push([ module.id, "._21NepOH08rF1rPISPcJ1xd{padding:9px 7px;background-color:#fafbfc;border:1px solid #f4f5f7;border-radius:5px;box-sizing:border-box;display:-webkit-box;display:flex;-webkit-box-flex:0;flex:0 1 auto;font-size:14px;-webkit-box-pack:justify;justify-content:space-between;line-height:1.42857143;max-width:100%;min-height:20px;overflow:hidden;-webkit-transition:background-color .2s ease-in-out,border-color .2s ease-in-out;transition:background-color .2s ease-in-out,border-color .2s ease-in-out;word-wrap:break-word}._21NepOH08rF1rPISPcJ1xd._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd .g2O1vEYlQydrVO1ltSaL_{background-color:#f4f5f7;border-color:rgba(9,30,66,.04);color:#b3bac5;pointer-events:none}._21NepOH08rF1rPISPcJ1xd._3sIiOsiTWiVtfbYK8E4cub{border-width:1px;padding:5px 7px}._21NepOH08rF1rPISPcJ1xd._3sIiOsiTWiVtfbYK8E4cub._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd._3sIiOsiTWiVtfbYK8E4cub ._3ZeCc2EAH6PGWNZEAdBiKw{background-color:#f4f5f7;border-color:rgba(9,30,66,.04);color:#b3bac5;pointer-events:none}._21NepOH08rF1rPISPcJ1xd._3sIiOsiTWiVtfbYK8E4cub._12Fgk9wtYo3dwelm4wlnnD{border-width:0;padding:6px 8px}._21NepOH08rF1rPISPcJ1xd._3sIiOsiTWiVtfbYK8E4cub._12Fgk9wtYo3dwelm4wlnnD._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd._12Fgk9wtYo3dwelm4wlnnD{border-width:0;padding:10px 8px;background-color:transparent}._21NepOH08rF1rPISPcJ1xd._12Fgk9wtYo3dwelm4wlnnD._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd._3sv4AtHelskpNGTvHzTkst{background-color:transparent;border:none}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst):hover:not(._2jR0mGLMUMFdE4mq7BTPIY){background-color:#f4f5f7;border-color:#f4f5f7}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst)._3ZeCc2EAH6PGWNZEAdBiKw{background-color:#f4f5f7;border-color:rgba(9,30,66,.04);color:#b3bac5;pointer-events:none}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst)._2fmsgQUQyXrMtkR7xRllHd:not(._2jR0mGLMUMFdE4mq7BTPIY){border-width:2px;padding:8px 6px;background-color:#fff;border-color:#4c9aff}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst)._2fmsgQUQyXrMtkR7xRllHd:not(._2jR0mGLMUMFdE4mq7BTPIY)._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst)._2fmsgQUQyXrMtkR7xRllHd:not(._2jR0mGLMUMFdE4mq7BTPIY)._3sIiOsiTWiVtfbYK8E4cub{border-width:2px;padding:4px 6px}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst)._2fmsgQUQyXrMtkR7xRllHd:not(._2jR0mGLMUMFdE4mq7BTPIY)._3sIiOsiTWiVtfbYK8E4cub._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst)._2fmsgQUQyXrMtkR7xRllHd:not(._2jR0mGLMUMFdE4mq7BTPIY)._12Fgk9wtYo3dwelm4wlnnD._13L7qAZ5VKkr4-ZgmmVzus{margin:-2px}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst)._2fmsgQUQyXrMtkR7xRllHd:not(._2jR0mGLMUMFdE4mq7BTPIY)._13L7qAZ5VKkr4-ZgmmVzus{margin:-1px}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T{border-width:2px;padding:8px 6px;border-color:#ffab00}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T._3ZeCc2EAH6PGWNZEAdBiKw{background-color:#f4f5f7;border-color:rgba(9,30,66,.04);color:#b3bac5;pointer-events:none}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T._3ZeCc2EAH6PGWNZEAdBiKw ._3Qc7j-faZ6lgEPSQp-K8aR{background-color:#f4f5f7;border-color:rgba(9,30,66,.04);color:#b3bac5;pointer-events:none}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T._3sIiOsiTWiVtfbYK8E4cub{border-width:2px;padding:4px 6px}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T._3sIiOsiTWiVtfbYK8E4cub._13L7qAZ5VKkr4-ZgmmVzus{padding:0}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T:hover{background-color:transparent;border-color:#ffab00}._21NepOH08rF1rPISPcJ1xd:not(._3sv4AtHelskpNGTvHzTkst).NjjYqYTEHybTz1twFYq_T._13L7qAZ5VKkr4-ZgmmVzus{margin:-1px}._39_xi6o9GSCz3zrnYiNUAo{-webkit-box-align:center;align-items:center;display:-webkit-box;display:flex;max-width:100%}._39_xi6o9GSCz3zrnYiNUAo._3ZeCc2EAH6PGWNZEAdBiKw{cursor:not-allowed}._3U4WjhEZuZdn_pJBdZz3jJ{max-width:100%}._3Qc7j-faZ6lgEPSQp-K8aR{-webkit-box-align:center;align-items:center;color:#ffab00;display:-webkit-box;display:flex;height:20px}.V0vgSz33wSma90-V2PoKz{-webkit-box-flex:1;flex:1 1 auto}.HOi5lbKFWkPL9agKb9M5Y{display:block}.NM_ak67-bjwKgGXYGs2eQ{color:#6c798f;font-size:12px;font-weight:600;line-height:1.33333333;padding:20px 0 4px}.NM_ak67-bjwKgGXYGs2eQ._1CCiv4pKOjdo9umlo-87h7{padding-top:4px}.NM_ak67-bjwKgGXYGs2eQ._3e1Ja85G44F93I1bdMdG8w{padding-bottom:0;padding-left:8px;padding-top:8px}.v4r-2-C2zJh9YdvFqHSHc{display:none}._2et9qrlFhsQQ7ktotr4k2V{padding-left:2px}", "" ]), 
    // exports
    exports.locals = {
        "content-container": "_21NepOH08rF1rPISPcJ1xd",
        contentContainer: "_21NepOH08rF1rPISPcJ1xd",
        paddingDisabled: "_13L7qAZ5VKkr4-ZgmmVzus",
        paddingDisabled: "_13L7qAZ5VKkr4-ZgmmVzus",
        "disabled-styles": "g2O1vEYlQydrVO1ltSaL_",
        disabledStyles: "g2O1vEYlQydrVO1ltSaL_",
        compact: "_3sIiOsiTWiVtfbYK8E4cub",
        compact: "_3sIiOsiTWiVtfbYK8E4cub",
        disabled: "_3ZeCc2EAH6PGWNZEAdBiKw",
        disabled: "_3ZeCc2EAH6PGWNZEAdBiKw",
        subtle: "_12Fgk9wtYo3dwelm4wlnnD",
        subtle: "_12Fgk9wtYo3dwelm4wlnnD",
        none: "_3sv4AtHelskpNGTvHzTkst",
        none: "_3sv4AtHelskpNGTvHzTkst",
        "read-only": "_2jR0mGLMUMFdE4mq7BTPIY",
        readOnly: "_2jR0mGLMUMFdE4mq7BTPIY",
        focused: "_2fmsgQUQyXrMtkR7xRllHd",
        focused: "_2fmsgQUQyXrMtkR7xRllHd",
        invalid: "NjjYqYTEHybTz1twFYq_T",
        invalid: "NjjYqYTEHybTz1twFYq_T",
        "warning-icon-wrapper": "_3Qc7j-faZ6lgEPSQp-K8aR",
        warningIconWrapper: "_3Qc7j-faZ6lgEPSQp-K8aR",
        "content-wrapper": "_39_xi6o9GSCz3zrnYiNUAo",
        contentWrapper: "_39_xi6o9GSCz3zrnYiNUAo",
        "dialog-container": "_3U4WjhEZuZdn_pJBdZz3jJ",
        dialogContainer: "_3U4WjhEZuZdn_pJBdZz3jJ",
        "fit-container-width": "V0vgSz33wSma90-V2PoKz",
        fitContainerWidth: "V0vgSz33wSma90-V2PoKz",
        label: "HOi5lbKFWkPL9agKb9M5Y",
        label: "HOi5lbKFWkPL9agKb9M5Y",
        "label-text": "NM_ak67-bjwKgGXYGs2eQ",
        labelText: "NM_ak67-bjwKgGXYGs2eQ",
        firstChild: "_1CCiv4pKOjdo9umlo-87h7",
        firstChild: "_1CCiv4pKOjdo9umlo-87h7",
        "inline-edit": "_3e1Ja85G44F93I1bdMdG8w",
        inlineEdit: "_3e1Ja85G44F93I1bdMdG8w",
        hidden: "v4r-2-C2zJh9YdvFqHSHc",
        hidden: "v4r-2-C2zJh9YdvFqHSHc",
        "required-asterisk": "_2et9qrlFhsQQ7ktotr4k2V",
        requiredAsterisk: "_2et9qrlFhsQQ7ktotr4k2V"
    };
}, /* 22 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 23 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
}, /* 24 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(15), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(8), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(9), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(10), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(11), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(12), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _classnames = __webpack_require__(16), _classnames2 = _interopRequireDefault(_classnames), _styles = __webpack_require__(20), _styles2 = _interopRequireDefault(_styles), Label = function(_PureComponent) {
        function Label() {
            return (0, _classCallCheck3.default)(this, Label), (0, _possibleConstructorReturn3.default)(this, (Label.__proto__ || (0, 
            _getPrototypeOf2.default)(Label)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Label, _PureComponent), (0, _createClass3.default)(Label, [ {
            key: "render",
            /* eslint-disable jsx-a11y/no-static-element-interactions */
            value: function() {
                var _classNames, labelClasses = (0, _classnames2.default)(_styles2.default.labelText, (_classNames = {}, 
                (0, _defineProperty3.default)(_classNames, _styles2.default.hidden, this.props.isLabelHidden), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.inlineEdit, "inline-edit" === this.props.appearance), 
                (0, _defineProperty3.default)(_classNames, _styles2.default.firstChild, this.props.isFirstChild), 
                _classNames));
                return _react2.default.createElement("label", {
                    className: _styles2.default.label,
                    htmlFor: this.props.htmlFor
                }, _react2.default.createElement("div", {
                    className: labelClasses
                }, _react2.default.createElement("span", {
                    onClick: this.props.onClick
                }, this.props.label), this.props.isRequired ? _react2.default.createElement("span", {
                    role: "presentation",
                    className: _styles2.default.requiredAsterisk
                }, "*") : null), this.props.children);
            }
        } ]), Label;
    }(_react.PureComponent);
    Label.propTypes = {
        /** the label text to display */
        label: _react.PropTypes.string.isRequired,
        /** whether to hide the label */
        isLabelHidden: _react.PropTypes.bool,
        /** onclick handler */
        onClick: _react.PropTypes.func,
        /** show a style indicating that the label is for a required field */
        isRequired: _react.PropTypes.bool,
        /** the labels control element */
        htmlFor: _react.PropTypes.string,
        /** any children to render, displayed underneath the label */
        children: _react.PropTypes.node,
        /** controls the appearance of the label */
        appearance: _react.PropTypes.oneOf([ "default", "inline-edit" ]),
        /** controls the top margin of the label */
        isFirstChild: _react.PropTypes.bool
    }, Label.defaultProps = {
        appearance: "default"
    }, exports.default = Label;
} ]);


//////////////////
// WEBPACK FOOTER
// ../field-text/~/@atlaskit/field-base/dist/bundle-cjs.js
// module id = 461
// module chunks = 0